import React, { useEffect, useState } from "react";
import {
  TextField,
  Box,
  Typography,
  Button,
  InputAdornment,
  SvgIcon,
} from "@mui/material";
import { useMutation } from "react-query";
import { makeStyles } from "@mui/styles";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import axios from "axios";
import { toast } from "react-toastify";
import useAuthStore from "../../store/login/useAuthStore";

const useStyles = makeStyles({
  formBox: {
    backgroundColor: "#fff",
    color: "#000",
    borderRadius: "34px",
    boxShadow: "0 0 10px rgba(0,0,0,0.16)",
    margin: "30px 0 50px",
    padding: "28px 16px 42px",
  },
});

export default function LoginForm() {
  const classes = useStyles();
  const [PasswordIsVisible, setPasswordIsVisible] = useState(false);
  const [username, setUsername] = useState();
  const [password, setPassword] = useState();
  const [captcha, setCaptcha] = useState();
  const [captchaImg, setCaptchaImg] = useState();
  const [token, setToken] = useState();
  const history = useHistory();

  const headers = {
    "Content-Type": "application/json",
    "x-user-agent": "12345dddd",
    "x-app-token": "xtf9rTlupdsf234A2XSxyMffgmfbJckG",
    "x-app-id": "123456",
  };

  const sendRequest = async ({ username, password, captcha }) => {
    return await axios.post(
      "https://kimia-shop.ir/api/web/v1/user/login",
      {
        username,
        password,
        captcha,
      },
      { headers }
    );
  };

  const userInfo = useMutation(sendRequest);

  const setAccessToken = useAuthStore((store) => store.setAccessToken);
  const setName = useAuthStore((store) => store.setName);
  const setFamily = useAuthStore((store) => store.setFamily);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (username && password && captcha) {
      userInfo.mutate(
        { username, password, captcha },
        {
          onSuccess: ({ data }) => {
            console.log(data);
            if (data?.status.code === -1) {
              toast.error(data?.status.text[0]);
            } else {
              setAccessToken(data?.result.access_token);
              setName(data?.result.name);
              setFamily(data?.result.family);
              history.push("/");
              localStorage.setItem(
                "token",
                JSON.stringify(data?.result.access_token)
              );
              window.location.reload(false);
            }
          },
        }
      );
    }
    else{
      toast.error('لطفا فیلدهای اجباری را پر کنید')
    }
  };

  const handleClickShowPassword = () => {
    setPasswordIsVisible(!PasswordIsVisible);
  };

  const captchaUrl = "https://kimia-shop.ir/api/web/v1/user/captcha";
  useEffect(() => {
    async function fetchData() {
      const response = await axios({
        method: "get",
        url: captchaUrl,
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          "x-user-agent": "12345dddd",
          "x-app-token": "xtf9rTlupdsf234A2XSxyMffgmfbJckG",
          "x-app-id": "123456",
        },
      });
      var bytes = new Uint8Array(response.data);
      var src = URL.createObjectURL(
        new Blob([bytes.buffer], { type: "image/png" } /* (1) */)
      );
      setCaptchaImg(src);
    }
    fetchData();
  }, [captchaUrl]);

  async function updateCaptcha() {
    const response = await axios({
      method: "get",
      url: captchaUrl,
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        "x-user-agent": "12345dddd",
        "x-app-token": "xtf9rTlupdsf234A2XSxyMffgmfbJckG",
        "x-app-id": "123456",
      },
    });
    var bytes = new Uint8Array(response.data);
    var src = URL.createObjectURL(
      new Blob([bytes.buffer], { type: "image/png" })
    );
    setCaptchaImg(src);
  };

  return (
    <>
      <form onSubmit={handleFormSubmit} className={classes.formBox}>
        <Typography variant="h2" mb={3}>
          ورود
        </Typography>

        <TextField
          id="username"
          name="username"
          label="نام کاربری"
          required
          onChange={(e) => setUsername(e.target.value)}
          value={username}
          fullWidth
          margin="normal"
          dir="rtl"
        />
        <TextField
          id="password"
          name="password"
          label="رمزعبور"
          required
          onChange={(e) => setPassword(e.target.value)}
          value={password}
          fullWidth
          margin="normal"
          type={PasswordIsVisible ? "text" : "password"}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SvgIcon
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  style={{ padding: 3, cursor: "pointer" }}
                >
                  {PasswordIsVisible ? <VisibilityOff /> : <Visibility />}
                </SvgIcon>
              </InputAdornment>
            ),
          }}
        />
        <TextField
          id="captcha"
          name="captcha"
          label="تصویر امنیتی"
          fullWidth
          required
          margin="normal"
          dir="rtl"
          onChange={(e) => setCaptcha(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <img
                  src={captchaImg}
                  onClick={updateCaptcha}
                  alt="enter captcha"
                />
              </InputAdornment>
            ),
          }}
        />
        <Box mt={2}>
          <Button
            variant="contained"
            disabled={userInfo.isLoading}
            type="submit"
            onClick={updateCaptcha}
            style={{ minWidth: "118px" }}
          >
            ورود
          </Button>
        </Box>
      </form>
    </>
  );
}
